import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { AuthConfig, AuthConfigService, AuthFacade } from '@rx-applications/shared/auth/data-access';

export const ssoResolver: ResolveFn<void> = (route: ActivatedRouteSnapshot): void => {
  const authFacade: AuthFacade = inject(AuthFacade);
  const authConfigService: AuthConfigService = inject(AuthConfigService);
  const authConfig: AuthConfig = authConfigService.config;

  const authCode: string = route.queryParamMap.get('authCode');
  const websiteId: number = authConfig?.websiteId;
  const isSsoEnabled: boolean = authConfig?.sso?.ssoEnabled === true;
  const websiteUrl: string = window.location.origin;

  if (!isSsoEnabled || !websiteId) return;

  if (isReturningFromIdp(authCode)) {
    authFacade.loginWithSSo(authCode, websiteId);
  } else {
    authFacade.loadSsoLogin(websiteId, websiteUrl);
  }
};

/**
 * Determines whether the user is returning from the identity provider with an auth code, after a successful login,
 * or it is the initial login page load.
 */
function isReturningFromIdp(authCode: string | null): boolean {
  return !!authCode?.trim();
}
